import React, { useState } from 'react';
import { FormControl } from 'react-bootstrap';
import { Eye, EyeSlash } from 'react-bootstrap-icons';

const PasswordInput = ({ field, form, type, className, style, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="position-relative">
      <FormControl
        {...field}
        {...props}
        type={showPassword ? 'text' : 'password'}
        className={className}
        style={{ ...style, paddingRight: '40px' }}
      />
      <span
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: 'absolute',
          top: '50%',
          right: '10px',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          zIndex: 5,
          color: '#6c757d',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {showPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
      </span>
    </div>
  );
};

export default PasswordInput;
